<!--  -->
<template>
  <div class="ball-container">
      <div v-for="(item, i) in balls" :key="i">
        <transition
          name="drop"
          @before-enter="beforeDrop"
          @enter="dropping"
          @after-enter="afterDrop"
        >
          <div class="ball" v-show="item.show">
            <div class="inner inner-hook"></div>
          </div>
        </transition>
      </div>
    </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      balls: [{ show: false }, { show: false }, { show: false }, { show: false }, { show: false }],
      dropBalls: [],
    };
  },
  computed: {},
  watch: {},
  methods: {
    drop(el) {
      //抛物
      for (let i = 0; i < this.balls.length; i++) {
        let ball = this.balls[i];
        if (!ball.show) {
          ball.show = true;
          ball.el = el;
          this.dropBalls.push(ball);
          return;
        }
      }
    },
    beforeDrop(el) {
      let count = this.balls.length;
      while (count--) {
        let ball = this.balls[count];
        if (ball.show) {
          let rect = ball.el.getBoundingClientRect(); //元素相对于视口的位置
          let x = rect.left -32;
          let y = -(window.innerHeight - rect.top - 62); //获取y
          console.log(x, y);
          el.style.display = '';
          el.style.webkitTransform = 'translateY(' + y + 'px)'; //translateY
          el.style.transform = 'translateY(' + y + 'px)';
          let inner = el.getElementsByClassName('inner-hook')[0];
          inner.style.webkitTransform = 'translateX(' + x + 'px)';
          inner.style.transform = 'translateX(' + x + 'px)';
        }
      }
    },
    dropping(el, done) {
      /*重置小球数量 样式重置*/
      let rf = el.offsetHeight;
      el.style.webkitTransform = 'translate3d(0,0,0)';
      el.style.transform = 'translate3d(0,0,0)';
      let inner = el.getElementsByClassName('inner-hook')[0];
      inner.style.webkitTransform = 'translate3d(0,0,0)';
      inner.style.transform = 'translate3d(0,0,0)';
      el.addEventListener('transitionend', done);
    },
    afterDrop(el) {
      /*初始化小球*/
      let ball = this.dropBalls.shift();
      if (ball) {
        ball.show = false;
        el.style.display = 'none';
      }
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.ball {
  position: fixed;
  bottom: 100px;
  left: 71px;
  z-index: 2;
  transition: all .4s cubic-bezier(0.49, -0.29, 0.75, 0.41); /* 贝塞尔曲线 */
}
.inner {
  width: 20px;
  height: 20px;
  background-color: #ff7f41;
  border-radius: 50%;
  transition: all .4s linear;
}

</style>
